module.exports = __webpack_public_path__ + "img/peach-shadow.7cae4b1d.svg";